// extracted by mini-css-extract-plugin
module.exports = {"heroContentWrap":"landingBg_heroContentWrap__2CAuU","heroContent":"landingBg_heroContent__2b09q"};